<template>
    <div class="demo-beds">
        <SphereNavigation color="orange" selected="demo-beds" />

        <div class="inner-content">
            <h1>{{$t('demo_beds.title')}}</h1>

            <div class="bed-list">
                <div v-for="item, idx in status" :key="item.bedId" class="bed-item">
                    <div class="bed">
                        <div class="status" :class="item.status"></div>
                    </div>
                    <button class="btn-basic blue" @click.prevent="selectBed(item)" >
                        {{$t('demo_beds.bed', {bed: idx + 1})}}
                    </button>
                </div>
            </div>
            <div v-if="(status.length == 0 || !isInShop) && !loading" class="no-beds">
                {{$t('demo_beds.no_beds') }}
            </div>
        </div>
    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import {crossbarStore} from "@/stores/crossbar";
import {demobedStore} from "@/stores/demobed";

export default {
    name : "DemoBeds",

    components : {
        SphereNavigation
    },

    created() {
        demobedStore().init();

        if (this.isInShop) {
            this.getStatus();
        }
    },

    computed: {
        isInShop() {
            return crossbarStore().isInShop;
        },

        status() {
            return demobedStore().status;
        },

        loading() {
            return demobedStore().loading;
        }
    },

    watch: {
        isInShop() {
            if (this.isInShop) {
                this.getStatus();
            }
        }
    },

    methods: {
        getStatus() {
            demobedStore().getStatus();
        },

        selectBed(bed) {
            demobedStore().bedId = bed.bedId;
            this.$router.push({name : "demo-beds-appointments"});
        }
    }
};
</script>

<style lang="scss" scoped>
.demo-beds {
    .inner-content {
        padding-top: 2%;
    }

    .bed-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        max-width: 40rem;

        .bed-item {
            width : 50%;
            min-height: 12rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 2rem;

            .bed {
                background-image: url('/img/icon-bed.svg');
                background-repeat: no-repeat;
                background-position: center;
                width: 100%;
                height : 100%;
                margin : 1rem 0;

                .status {
                    width : 100%;
                    height: 2.25rem;
                    background-repeat: no-repeat;
                    background-size: contain;
                    background-position: center;
                    margin-top: 4rem;

                    &.offline {
                        background-image : url('/img/icon-cocon-disconnected.png');
                    }

                    &.online {
                        background-image : url('/img/icon-cocon-connected.png');
                    }
                }
            }

            .btn-basic {
                padding: 0 1.5rem;
                height: 3rem;
                line-height: 3rem;
            }

            @for $i from 1 through 5 {
                &:nth-child(#{$i}) {
                    @include slideIntroAnimation(basicSlideIntro, 450ms, #{$i * 250ms});
                }
            }
        }
    }

    .no-beds {
        text-align: left;
        margin-top: 2rem;

        @include slideIntroAnimation(basicSlideIntro, 450ms, 250ms);
    }
}
</style>